////
/// ============================================================================
/// COMPONENT / Variations
/// ============================================================================
///
/// @see https://stackoverflow.com/a/53073346
///
/// @group components
////

export default () => {
    (($) => {
        $(document).on('change', '.js-variation input', function () {
            $('.js-variation input:checked').each(function () {
                $('select[name="' + this.getAttribute("name") + '"]')
                    .val(this.getAttribute("value"))
                    .trigger('change');
            });
        });

        $(document).on('woocommerce_update_variation_values', function () {
            $('.js-variation input').each(function () {
                let $input = $(this);
                let $option = $('select[name="' + this.getAttribute("name") + '"] option[value="' + this.getAttribute("value") + '"]');

                $input.removeAttr('disabled');
                $input.prop('disabled', $option.is(':disabled'));
            });
        });
    })(jQuery);
}
